export const GET_USER_MANAGEMENT = 'OVRS_APPLICATIONS/get_user-_management';
export const GET_SINGLE_USER_MANAGEMENT =
  'OVRS_APPLICATIONS/get_single_user_management';
export const UPDATE_USER_MANAGEMENT =
  'OVRS_APPLICATIONS/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'OVRS_APPLICATIONS/create_brangay';
export const REMOVE_USER_MANAGEMENT =
  'OVRS_APPLICATIONS/remove_user_management';

export const ASSESS_RECEIPT = 'OVRS_applications/assess_receipt';

export const GET_OVR_TRANSACTIONS = 'OVRS_APPLICATION/get_ovr_transactions';
export const SHOW_OVR = 'OVRS_APPLICATION/show_ovr';
export const START_ASSESSMENT = 'OVRS_APPLICATION/start_assessment';
export const VALIDATE_OVR_TRANSACTION =
  'OVRS_APPLICATION/validate_ovr_transaction';
export const APPROVE_TICKET = 'OVRS_APPLICATION/approve_ticket';
export const REJECT_TICKET = 'OVRS_APPLICATION/reject_ticket';
export const TAG_AS_RECEIVE = 'OVRS_APPLICATION/tag_as_receive';
export const OR_CHECK = 'OVRS_APPLICATION/or_check';
export const CANCEL_SOA = 'OVRS_APPLICATION/cancel_soa';
export const CANCEL_APPLICATION = 'OVRS_APPLICATION/cancel_application';

export const FORM_DATA = {
  photo: '',
  title: '',
  description: '',
  start_date: '',
  end_date: '',
};

export const OVR_URI =
  'api/v1/administrators/transaction_histories/ovr/{id}/view_soa';
export const OVR_URI_GENERATE =
  'api/v1/administrators/transaction_histories/ovrs/{id}/generate';
export const TAG_AS_PRINTED_TRANSACTION = 'OVRS_APPLICATION/tag_as_printed';
export const APPLY_PENALTY = 'OVRS_APPLICATION/apply_penalty';
export const GENERATE_SOA = 'OVRS_APPLICATION/generate_soa';
export const APPROVE_SOA = 'OVRS_APPLICATION/approve_soa';
export const REGENERATE_SOA = 'OVRS_APPLICATION/regenerate_soa';
